import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets.app/images/sign-up-google.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  id: "sign-in-with-google-container-big",
  class: "googleSigninBig"
}
const _hoisted_4 = {
  key: 1,
  id: "sign-in-with-google-container-small",
  class: "googleSigninSmall"
}

import { onBeforeMount, onMounted, ref } from 'vue'

import { SocialAuthView } from '@/models/auth/social'
import { GoogleAuthView, AuthMode } from '@/models/auth/google'
import { GoogleNativeAuthView } from '@/models/auth/google.native'


export default /*@__PURE__*/_defineComponent({
  __name: 'GoogleSignInButton',
  props: {
    view: {},
    authMode: {},
    showButton: { default: 'all' }
  },
  setup(__props: any) {

const props = __props

const isNativeApp = ref(false)

onBeforeMount(() => {
  isNativeApp.value = props.view instanceof GoogleNativeAuthView
})

onMounted(async () => {
  if (props.view instanceof GoogleAuthView) {
    await props.view.containerComponentHasMounted(props.authMode)
  }
})

async function login(): Promise<void> {
  if (props.view instanceof GoogleNativeAuthView) {
    await props.view.start()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isNativeApp.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            class: "button googleSignIn shortform-sign-up__button",
            onClick: login
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              class: "button__img",
              src: _imports_0,
              alt: ""
            }, null, -1),
            _createElementVNode("span", { class: "button__text d-none d-md-inline" }, "Sign up with Google", -1),
            _createElementVNode("span", { class: "button__text d-md-none" }, "Sign up with Google", -1)
          ]))])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.showButton === 'all' || __props.showButton === 'big')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true),
          (__props.showButton === 'all' || __props.showButton === 'small')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})